<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="defaultHref" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title
      [innerHTML]="(surveyField$ | async) ? (surveyField$ | async)?.question : ('ADMIN_SURVEYS.ADD_FIELD' | translate)"
    ></ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="survey-definition-form">
  <div class="white-wrapper">
    <span
      class="survey-definition-form__title"
      [innerHTML]="(surveyField$ | async) ? (surveyField$ | async)?.question: ('ADMIN_SURVEYS.ADD_FIELD' | translate)"
    ></span>
    <form class="survey-definition-form__form" [formGroup]="form">
      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_QUESTION_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="question"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_TYPE_LABEL' | translate"
        ></ion-label>
        <ion-select class="survey-definition-form__form__item__input" type="text" formControlName="type">
          <ion-select-option
            *ngFor="let type of availableTypes"
            [value]="type"
            [innerHTML]="'ADMIN_SURVEYS.FIELD_TYPES.' + type | uppercase | translate"
          ></ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item
        class="survey-definition-form__form__item"
        [class.--is-hidden]="form.value.type !== 'select' && form.value.type !== 'multiselect'"
      >
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_OPTIONS_LABEL' | translate"
        ></ion-label>
        <ion-input
          class="survey-definition-form__form__item__input"
          type="text"
          formControlName="options"
          [placeholder]="'ADMIN_SURVEYS.FIELD_OPTIONS_PLACEHOLDER' | translate"
        ></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_STANDARD_VALUE_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="defaultValue"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_ORDER_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="number" step="1" formControlName="order"></ion-input>
      </ion-item>

      <ion-item
        class="survey-definition-form__form__item"
        [class.--is-hidden]="form.value.type !== 'number' && form.value.type !== 'range'"
      >
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_MINIMUM_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="number" step="1" formControlName="min"></ion-input>
      </ion-item>

      <ion-item
        class="survey-definition-form__form__item"
        [class.--is-hidden]="form.value.type !== 'number' && form.value.type !== 'range'"
      >
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_MAXIMUM_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="number" step="1" formControlName="max"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_HELP_TEXT_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="helpText"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_HELP_URL_LABEL' | translate"
        ></ion-label>
        <ion-input class="survey-definition-form__form__item__input" type="text" formControlName="helpUrl"></ion-input>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.DESCRIPTION' | translate"
        ></ion-label>
        <ion-textarea ngDefaultControl class="survey-definition-form__form__item__textarea" formControlName="description"></ion-textarea>
      </ion-item>

      <ion-item class="survey-definition-form__form__item">
        <ion-label
          class="survey-definition-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_SURVEYS.FIELD_REQUIRED_LABEL' | translate"
        ></ion-label>
        <ion-toggle class="survey-definition-form__form__item__input" type="text" formControlName="required"></ion-toggle>
      </ion-item>

      <div class="survey-definition-form__form__buttons">
        <div
          *ngIf="(surveyField$ | async)?.imageUrl || image?.base64String"
          class="survey-definition-form__form__buttons__remove"
          (click)="removeImage()"
        >
          x
        </div>
        <ion-button class="survey-definition-form__form__buttons__button" (click)="loadImage()">
          <ion-img
            *ngIf="image?.base64String; else surveyFieldImage"
            src="data:image/{{image.format}};base64,{{image.base64String}}"
          ></ion-img>
          <ng-template #surveyFieldImage>
            <ion-img *ngIf="(surveyField$ | async)?.imageUrl; let source; else cameraIcon" [src]="source"></ion-img>
          </ng-template>
          <ng-template #cameraIcon><ion-icon name="camera"></ion-icon></ng-template>
        </ion-button>
      </div>

      <div class="survey-definition-form__form__footer">
        <ion-button class="button --tertiary" [innerHTML]="'BUTTONS.CANCEL' | translate | lowercase" (click)="cancel()"></ion-button>
        <ion-button class="button --primary" [disabled]="form.invalid || form.pristine || (loading$ | async)" (click)="save()">
          <ion-spinner *ngIf="loading$ | async; else text"></ion-spinner>
          <ng-template #text>
            <span [innerHTML]="'BUTTONS.SAVE' | translate"></span>
          </ng-template>
        </ion-button>
      </div>
    </form>
  </div>
</ion-content>
